import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Home.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isMainPage = ['/home', '/case-studies', '/contact', '/', '/gate'].includes(location.pathname);

  const handleBack = () => {
    navigate(-1);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-content">
          <div className="nav-left">
            {!isMainPage && (
              <button onClick={handleBack} className="nav-link back-button">
                ← Back
              </button>
            )}
            <a href="/home" className="nav-logo">AS</a>
          </div>
          <div className="nav-links">
            <a href="/home" className="nav-link">Home</a>
            <a href="/case-studies" className="nav-link">Case Studies</a>
            <a href="#contact" className="nav-link">Contact</a>
          </div>
          <button
            className={`hamburger ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <a href="/home" className="mobile-link" onClick={closeMenu}>Home</a>
        <a href="/case-studies" className="mobile-link" onClick={closeMenu}>Case Studies</a>
        <a href="#contact" className="mobile-link" onClick={closeMenu}>Contact</a>
      </div>

      {isMenuOpen && <div className="mobile-menu-overlay" onClick={closeMenu}></div>}
    </>
  );
};

export default Navigation; 